import visTypeCheckers from '../../../../../../types/visTypeCheckers';
import { isKpiRow } from '../../../../../../hooks/kpiTypeCheckers';

const replaceMetricIds = (
  vis:
    | V5ChartDefinition
    | VisualisationDefinitions.Reminders
    | VisualisationDefinitions.Gauge
    | VisualisationDefinitions.SingleMetricDateMatrix
    | VisualisationDefinitions.PaceMatrix
    | VisualisationDefinitions.GroupVsRemainder
    | VisualisationDefinitions.RankingMatrix
    | VisualisationDefinitions.EntityInformationTable,
  findMetricId: string,
  replaceMetricId: string,
) => {
  if (visTypeCheckers.isGeneralGoal(vis)) {
    vis.kpis = vis.kpis.map((k) => {
      return {
        ...k,
        metricId: k.metricId === findMetricId ? replaceMetricId : k.metricId,
      };
    });
  } else if (visTypeCheckers.isRankingMatrix(vis)) {
    vis.metrics = vis.metrics.map((m) => {
      return {
        ...m,
        metricId: m.metricId === findMetricId ? replaceMetricId : m.metricId,
      };
    });
  } else if (visTypeCheckers.isMetricList(vis)) {
    vis.list = vis.list.map((li) => {
      return {
        ...li,
        metricId: li.metricId === findMetricId ? replaceMetricId : li.metricId,
      };
    });
  } else if (visTypeCheckers.isScorecard(vis)) {
    vis.kpis = vis.kpis.map((k) => {
      if (!isKpiRow(k)) return k;
      return {
        ...k,
        metricId: k.metricId === findMetricId ? replaceMetricId : k.metricId,
      };
    });
  } else if (visTypeCheckers.isSingleMetricDateMatrix(vis)) {
    vis.metricId =
      vis.metricId === findMetricId ? replaceMetricId : vis.metricId;
  } else if (visTypeCheckers.isV5ChartDef(vis)) {
    vis.series = vis.series.map((s) => {
      return {
        ...s,
        metricId: s.metricId === findMetricId ? replaceMetricId : s.metricId,
      };
    });
  } else if (visTypeCheckers.isEntityInformationTable(vis)) {
    vis.rows = vis.rows.map((r) => {
      if (r.type !== 'metric') return r;
      return {
        ...r,
        metricId: r.metricId === findMetricId ? replaceMetricId : r.metricId,
      };
    });
  }
  return vis;
};

export default replaceMetricIds;
